import PropTypes from 'prop-types';
import PerformanceValue from '../../../atoms/performance-value';
import format from '../../../../utils/format';
import styles from './performance-element.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const PerformanceElement = ({ returnValue, isLinkedPerformance, year, showSalesCharge }) => {
  const fontStyle = showSalesCharge ? 'font-italic' : '';
  const value = showSalesCharge ? returnValue.salesCharge : returnValue.standard;
  let disclosureSuperScript = '';
  /*Checking if returnValue is a number, because 0 is a falsey value */
  const isNumber = format.isValidNumber(value);

  if (isNumber && isLinkedPerformance[year]) {
    disclosureSuperScript = '*';
  }


  return (
    <>
      <span {...className('performance', 'numbers', 'years', fontStyle)}>
        <PerformanceValue value={value} />
        <span {...className('text-dark')}>{disclosureSuperScript} </span>
      </span>
    </>
  );
};

PerformanceElement.propTypes = {
  returnValue: PropTypes.object,
  isLinkedPerformance: PropTypes.object,
  year: PropTypes.string,
  showSalesCharge: PropTypes.bool
};

export default PerformanceElement;
